module.exports = __webpack_public_path__ + "static/media/bg.c82cf5fe.png";